<template>
  <v-container>
    <v-icon @click="$emit('prevYear')">
      mdi-chevron-left
    </v-icon>
    <span>{{viewedYear}}</span>
    <v-icon @click="$emit('nextYear')">
      mdi-chevron-right
    </v-icon>
  </v-container>
</template>
<script>
export default {
  name: 'CalendarYear',
  props: {
    viewedYear: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style lang="scss" scoped>
span {
  padding:0 10px;
}
.v-icon {
  font-size:1.3rem !important;
  color:$bh-gray--3;
}
</style>